export default {
  apiKey: 'AIzaSyAX8fZ4iohoTOoMxkX3yYk_49Je54TeVE0',
  authDomain: 'raize-fit.firebaseapp.com',
  projectId: 'raize-fit',
  storageBucket: 'raize-fit.appspot.com',
  messagingSenderId: '175141289673',
  appId: '1:175141289673:web:8231dfe1af0c21a2685718',
  measurementId: 'G-D9SWF8W67L',
};
